import Vue from "vue";
import Vuetify, {
} from "vuetify/lib/framework";
import {
  VProgressLinear,
  VSelect,
  VPagination,
  VDataTable,
  VSpacer
} from "vuetify/lib/";
import fr from "vuetify/es5/locale/fr";
import "@mdi/font/css/materialdesignicons.css" // Ensure you are using css-loader


Vue.use(Vuetify, {
  components: { VProgressLinear, VSelect, VPagination, VDataTable, VSpacer },
});

export default new Vuetify({
  lang: {
    locales: {
      fr,
    },
    current: "fr",
  },
  icons: {
    iconfont: "mdi", // default - only for display purposes
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: "#148282",
        secondary: "#003F88",
        accent: "#F45D5D",

        information: "#0063CB",
        success: "#18753C",
        warning: "#FFC107",
        error: "#CE0500",

        lightprimary: "#4fa1a1",
        darkprimary: "#00383a",
        darkgrey: "#757575",
        grey: "#E5E5E5",
        lightgrey: "#f5f5f5",
        black: "#000000",
        background: "#FEFEFE",
      },
    },
  },
});
